import { message } from "antd";
import React, { useState } from "react";

import { convertEmailPreviewFiveSimvol } from "../../../../../../../utils/helpers";
import variableLanguage from "../../../../../../../utils/hookGetVariablesLanguage";
import useTimer from "../../../../../../../utils/hooks/useTimer";
import requests from "../../../../../../axios/requests";
import Button from "../../../../../../components/Button/Button";
import PrevButton from "../../../../../../components/PrevButton/PrevButton";
import ModalWelcome from "../../../../../../pages/Auth/ModalWelcome/ModalWelcome";

function AuthPhoneMail({ setToggleHeaderFoter, sessionId }) {
  const variables_71 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_71",
  });
  const variables_70 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_70",
  });
  const variables_69 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_69",
  });
  const variables_72 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_72",
  });
  const variables_73 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_73",
  });
  const variables_74 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_74",
  });
  const variables_75 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_75",
  });
  const variables_9 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_9",
  });
  const variables_76 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_76",
  });
  const variables_66 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_66",
  });
  const variables_77 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_77",
  });
  const variables_78 = variableLanguage({
    keyPage: "authorization",
    keyVariable: "variables_78",
  });
  const { timeLeft, isFinished, isRunning, start, pause, resume, reset } =
    useTimer(60, () => {
      console.log("Таймер завершен!");
    });
  const [valuePhone, setValuePhone] = useState("");
  const [valuePhoneCode, setValuePhoneCode] = useState("");

  const [valueEmail, setValueEmail] = useState("");
  const [valueEmailCode, setValueEmailCode] = useState("");
  const [step, setStep] = useState(1);
  const [image, setImage] = useState("");
  const [name, setName] = useState("");

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const onlyDigitsPattern = /^\d+$/;

  const inputConfirmHandler = (e) => {
    const value = e.target.value.replace(/[^\d+]/g, "");
    if (value.length <= 12) setValuePhone(value);
  };
  const inputConfirmHandlerPhoneCode = (e) => {
    setValuePhoneCode(e.target.value);
  };
  const inputConfirmHandlerEmail = (e) => {
    setValueEmail(e.target.value.trim().toLowerCase());
  };
  const inputConfirmHandlerEmailCode = (e) => {
    setValueEmailCode(e.target.value);
  };
  const normalizePhoneForBackend = (raw) => {
    let digits = raw.replace(/\D/g, "");
    if (digits.length > 0 && digits[0] === "8") {
      digits = "7" + digits.slice(1);
    }
    return digits;
  };

  //Шаг 1
  const loginHandlerPhone = (e) => {
    e.preventDefault();
    const phone = normalizePhoneForBackend(valuePhone);
    if (phone.length !== 11 || phone[0] !== "7") {
      message.warn("Номер телефона должен быть в формате 7XXXXXXXXXX или 8XXXXXXXXXX");
      return;
    }
    setValuePhone(phone);

    requests.auth
      .request_sms({ phone })
      .then(({ data }) => {
        setToggleHeaderFoter(false);
        if (data?.message == "Код отправлен на телефон") {
          setStep(2);
          reset();
          start();
        }
        if (data?.message == "Код отправлен на почту") {
          setStep(4);
          reset();
          start();
          setValueEmail(data.email);
        }
      })
      .catch((error) => {
        if (error.response?.status === 500) {
          message.warn("Не удалось отправить СМС. Повторите попытку позже.");
          return;
        }
        let messageDetail;
        if (error.response?.data?.detail) {
          messageDetail = error.response.data.detail;
        } else if (error.detail) {
          messageDetail = error.detail;
        } else {
          messageDetail = "Неизвестная ошибка";
        }
        message.warn(messageDetail);
      });
  };
  //Шаг 2
  const loginHandlerPhoneCode = (e) => {
    e.preventDefault();
    if (!onlyDigitsPattern.test(valuePhoneCode)) {
      message.warn(variables_71);
      return;
    }
    requests.auth
      .verify_phone({ phone: valuePhone, code: valuePhoneCode })
      .then((response) => {
        if (response?.status === 203) {
          message.warn("Некорректный код. Повторите попытку.");
          return;
        }
        setStep(3);
        reset();
        start();
      })
      .catch((error) => {
        if (error.response?.status === 500) {
          message.warn("Не удалось отправить СМС, повторите попытку позже.");
          return;
        }
        message.warn(variables_69);
      });
  };
  //Шаг 3
  const loginHandlerEmail = (e) => {
    e.preventDefault();
    if (!emailPattern.test(valueEmail)) {
      message.warn(variables_72);
      return;
    }
    requests.auth
      .verify_email({ email: valueEmail, mode: "register" })
      .then(() => {
        setStep(4);
        reset();
        start();
      })
      .catch((error) => {
        console.log("error", error);
        message.warn(variables_73);
      });
  };
  //Шаг 4
  const loginHandlerEmailCode = (e) => {
    e.preventDefault();
    if (!onlyDigitsPattern.test(valueEmailCode)) {
      message.warn(variables_71);
      return;
    }
    requests.users
      .validate_sms({
        code: valueEmailCode,
        email: valueEmail,
        phone: valuePhone,
      })
      .then((response) => {
        if (response.status === 203) {
          message.warn("Срок жизни кода истек. Получите код снова.");
          return;
        }

        setStep(5);

        setImage(response.data.image);
        setName(response.data.name);

        if (response.data?.user_exists) {
          // если неаутентифицированный пользователь просматривал страницу, то редирект его на эту страницу.
          if (window.localStorage.getItem("previous_course_link")) {
            window.localStorage.setItem("token", response.data.auth_token);
            window.localStorage.setItem("username", response.data.name);
            window.localStorage.setItem("last_name", response.data.last_name);
            window.localStorage.setItem(
              "middle_name",
              response.data.middle_name
            );
            window.location.href = window.localStorage.getItem(
              "previous_course_link"
            );
            setTimeout(() => {
              window.localStorage.removeItem("previous_course_link");
            }, 1000);
            return;
          }

          window.localStorage.setItem("token", response.data.auth_token);
          window.localStorage.setItem("username", response.data.name);
          window.localStorage.setItem("last_name", response.data.last_name);
          window.localStorage.setItem("middle_name", response.data.middle_name);
        } else {
          console.log("иначе вернуть куда то там");
        }
      })
      .catch((error) => console.error(error));
  };
  return (
    <div>
      {step === 1 && (
        <>
          <input
            className="auth-item input"
            value={valuePhone}
            onChange={inputConfirmHandler}
            placeholder={variables_74}
            maxLength={12}
          />

          <Button
            text={variables_75}
            click={(e) => loginHandlerPhone(e)}
            zIndex={3}
            className={"AuthFormBtn"}
            margin="20px 0"
          />
        </>
      )}
      {step === 2 && (
        <>
          <PrevButton click={() => setStep(1)} />
          <input
            className="auth-item input"
            value={valuePhoneCode}
            onChange={inputConfirmHandlerPhoneCode}
            placeholder={variables_9}
            maxLength={4}
          />
          {!isFinished ? (
            <div className="auth-item_timer">Осталось {timeLeft} секунд</div>
          ) : (
            <div className="auth-item_again_code" onClick={loginHandlerPhone}>
              Код не пришел? <span>&nbsp;Получить код снова</span>
            </div>
          )}
          <Button
            text={variables_76}
            click={loginHandlerPhoneCode}
            zIndex={3}
            className={"AuthFormBtn"}
            margin="20px 0"
          />
        </>
      )}
      {step === 3 && (
        <>
          <input
            className="auth-item input"
            value={valueEmail}
            onChange={inputConfirmHandlerEmail}
            placeholder={variables_66}
          />
          <Button
            text={variables_77}
            click={loginHandlerEmail}
            zIndex={3}
            className={"AuthFormBtn"}
            margin="20px 0"
          />
        </>
      )}
      {step === 4 && (
        <>
          <PrevButton click={() => setStep(3)} />
          <input
            className="auth-item input"
            value={valueEmailCode}
            onChange={inputConfirmHandlerEmailCode}
            placeholder={
              variables_78 + convertEmailPreviewFiveSimvol(valueEmail)
            }
            maxLength={4}
          />
          {!isFinished ? (
            <div className="auth-item_timer">Осталось {timeLeft} секунд</div>
          ) : (
            <div className="auth-item_again_code" onClick={loginHandlerPhone}>
              Код не пришел? <span>&nbsp;Получить код снова</span>
            </div>
          )}
          <Button
            text={variables_70}
            click={loginHandlerEmailCode}
            zIndex={3}
            className={"AuthFormBtn"}
            margin="20px 0"
          />
        </>
      )}
      {step === 5 && (
        <ModalWelcome
          image={image}
          name={name}
          setImage={setImage}
          sessionId={sessionId}
        />
      )}
    </div>
  );
}

export default AuthPhoneMail;
